"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("reflect-metadata");
exports.CodableSymbol = Symbol("Codable");
exports.Codable = (type, convert = false, codingKey) => {
    return (target, fieldKey) => {
        const key = codingKey || fieldKey;
        const condingKeys = Reflect.getMetadata(exports.CodableSymbol, target) || {};
        condingKeys[key] = { type, convert };
        Reflect.defineMetadata(exports.CodableSymbol, condingKeys, target);
    };
};
//# sourceMappingURL=Codable.js.map